import React from 'react';
import Header from '../containers/header/Header';
import Philosophy from '../containers/philosophy/Philosophy';
import './pages.css';

const AboutPage = () => {
  return (
    <div className="page page--about">
      <section className="page__hero page__hero--about page__hero--compact">
        <div className="page__hero-content">
          <h1 className="gradient__text page__hero-title">About Bollywood Ki Dhun</h1>
        </div>
      </section>

      <div className="section__padding">
        <Header />
      </div>

      <Philosophy />
    </div>
  );
};

export default AboutPage;
